import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-issue-sellerposting-officerepreport',
  templateUrl: './issue-sellerposting-officerepreport.component.html',
  styleUrls: ['./issue-sellerposting-officerepreport.component.scss']
})
export class IssueSellerpostingOfficerepreportComponent {
  sellerData: any[] = [];
  updateStatus: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<IssueSellerpostingOfficerepreportComponent>
  ) {
    this.sellerData = data.sellerData;
    this.updateStatus = data.updateStatus;
  }
  getOfficeTotalCopies(office: any): number {
  if (!office.data) return 0;
  return office.data.reduce((sum: number, row: any) => sum + (Number(row.issue_copies) || 0), 0);
}
getGrandTotalCopies(): number {
  return this.sellerData.reduce((grandSum: number, office: any) => {
    return grandSum + this.getOfficeTotalCopies(office);
  }, 0);
}

  // Print table section
  print() {
    const printContents = document.getElementById('print-section')?.innerHTML;
    if (printContents) {
      const popupWin = window.open('', '_blank', 'width=1200,height=800');
      popupWin?.document.open();
      popupWin?.document.write(`
        <html>
          <head>
            <title>Dispatchwise Report</title>
            <style>
              table { border-collapse: collapse; width: 100%; }
              th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; }
            </style>
          </head>
          <body onload="window.print(); window.close()">
            ${printContents}
          </body>
        </html>
      `);
      popupWin?.document.close();
    }
  }

  // Export as CSV
  exportExcel(fileName: string) {
    let csvContent = 'data:text/csv;charset=utf-8,';
    csvContent += 'Office Rep,Seller,Taluka,District,Representative,Copies\n';

    this.sellerData.forEach(office => {
      office.data.forEach(row => {
        csvContent += `${office.office_representation_id},${row.issue_seller_id},${row.taluka},${row.district},${row.representative_id},${row.issue_copies}\n`;
      });
    });

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
